import React from "react";
import ReactApexChart from "react-apexcharts";

const LineColumnAreaData = {
  series: [
    {
      name: "Expenses",
      type: "column",
      data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30, 18],
    },
    {
      name: "Maintenance",
      type: "area",
      data: [44, 55, 41, 42, 22, 43, 21, 41, 56, 27, 43, 27],
    },
    {
      name: "Profit",
      type: "line",
      data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39, 51],
    },
  ],
  options: {
    chart: {
      height: 350,
      type: "line",
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: [0, 1, 1],
      dashArray: [0, 0, 5],
      curve: "smooth",
    },
    plotOptions: {
      bar: {
        columnWidth: "18%",
      },
    },
    legend: {
      show: false,
    },
    colors: ["#0ab39c", "rgba(212, 218, 221, 0.18)", "rgb(251, 77, 83)"],
    fill: {
      opacity: [0.85, 0.25, 1],
      gradient: {
        shade: "light",
        type: "vertical",
        opacityFrom: 0.85,
        opacityTo: 0.55,
      },
    },
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    markers: {
      size: 0,
    },
    xaxis: {
      type: "category",
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          return y !== undefined ? `${y.toFixed(0)} points` : "";
        },
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  },
};

const LineColumnArea = () => {
  return (
    <React.Fragment>
      <ReactApexChart
        options={LineColumnAreaData.options}
        series={LineColumnAreaData.series}
        type="line"
        height={350}
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export default LineColumnArea;
